import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { ROLE, useAuth } from '../../../../../app/modules/auth'
import { IsGranted } from '../../../../../app/modules/auth/PrivateRoute'
import { useLocation } from 'react-router'
import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

// Кастомный компонент для пункта меню касс с особой логикой активности
const SidebarMenuItemCashboxes: FC<{
  to: string
  title: string
  hasBullet?: boolean
  roles?: Array<ROLE>
}> = ({ to, title, hasBullet = false, roles = [] }) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth()

  // Кастомная логика для определения активности касс
  const isActive = pathname === '/settings/cashboxes' || pathname.startsWith('/settings/cashbox/')

  if (!IsGranted(roles, currentUser)) {
    return <></>
  }

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
    </div>
  )
}

// Кастомный компонент для пункта меню реквизитов с особой логикой активности
const SidebarMenuItemRequisites: FC<{
  to: string
  title: string
  hasBullet?: boolean
  roles?: Array<ROLE>
}> = ({ to, title, hasBullet = false, roles = [] }) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth()

  // Кастомная логика для определения активности реквизитов
  const isActive = pathname.startsWith('/settings/requisite')

  if (!IsGranted(roles, currentUser)) {
    return <></>
  }

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
    </div>
  )
}

// Кастомный компонент для пункта меню логи -> внешние транзакции
const SidebarMenuItemExternalTransactions: FC<{
  to: string
  title: string
  hasBullet?: boolean
  roles?: Array<ROLE>
}> = ({ to, title, hasBullet = false, roles = [] }) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth()

  // Кастомная логика для определения активности реквизитов
  const isActive = pathname.startsWith('/logs/external-transactions')

  if (!IsGranted(roles, currentUser)) {
    return <></>
  }

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
    </div>
  )
}

// Кастомный компонент для пункта меню шаблонов сообщений с особой логикой активности
const SidebarMenuItemMTemplates: FC<{
  to: string
  title: string
  hasBullet?: boolean
  roles?: Array<ROLE>
}> = ({ to, title, hasBullet = false, roles = [] }) => {
  const { pathname } = useLocation()
  const { currentUser } = useAuth()

  // Кастомная логика для определения активности реквизитов
  const isActive = pathname === '/settings/message/templates' || pathname === '/settings/message/senders'

  if (!IsGranted(roles, currentUser)) {
    return <></>
  }

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
    </div>
  )
}

const SidebarMenuMain = () => {
  const { currentUser } = useAuth()

  return (
    <>
      {IsGranted([ROLE.ROLE_MANAGER], currentUser) ? (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Служебные</span>
          </div>
        </div>
      ) : (
        ''
      )}
      <SidebarMenuItemWithSub
        to='/staff/'
        title='Сотрудники'
        icon='security-user'
        fontIcon='bi-person'
        roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
      >
        <SidebarMenuItem
          to='/staff/active'
          title='Активные'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/staff/blocked'
          title='Заблокированные'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/settings/'
        title='Настройки'
        icon='gear'
        fontIcon='bi-gear'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_CASHIER,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItemRequisites
          to='/settings/requisite'
          title='Реквизиты'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_CASHIER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}
        />
        <SidebarMenuItemCashboxes
          to='/settings/cashboxes'
          title='Кассы'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/merchants'
          title='Мерчанты'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/cashboxes-priorities'
          title='Приоритет касс'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/payment-adapters'
          title='Платежные адаптеры'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/payment-adapter-priorities'
          title='Приоритет платежных адаптеров'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/adapter-routing'
          title='Карта покрытия маршрутизации'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR]}
        />
        <SidebarMenuItemMTemplates
          to='/settings/message/templates'
          title='Шаблоны сообщений'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/system'
          title='Системные настройки'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/overpayment-reasons'
          title='Причины переоплат'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/matching-profiles'
          title='Профили мэтчинга'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/dispute-reasons'
          title='Причины диспута'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/deposit-cancel-reasons'
          title='Причины отмены депозита'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/settings/commission-rules'
          title='Комиссии'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/logs/'
        title='Логи'
        icon='clipboard'
        fontIcon='bi-clipboard'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/logs/employees'
          title='Сотрудники'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/logs/requisites'
          title='Реквизиты'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/logs/push-and-sms'
          title='Push и SMS'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/logs/risk-score'
          title='Логи риск-баллов'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
            ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/logs/external-user-flags'
          title='Логи изменений флагов'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItemExternalTransactions
          to='/logs/external-transactions'
          title='Внешние транзакции'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
        <SidebarMenuItem
          to='/logs/audit'
          title='Аудит интеграций'
          hasBullet={true}
          roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}
        />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Общие</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/client/list'
        title='Клиенты'
        icon='profile-circle'
        roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}
      />
      <SidebarMenuItemWithSub
        to='/payment-tickets/'
        title='Тикеты пополнения'
        icon='double-up'
        fontIcon='bi-person'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_CASHIER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_SENIOR_OPERATOR,
          ROLE.ROLE_OPERATOR,
          ROLE.ROLE_MATCHING_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/payment-tickets/active'
          title='Активные'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_CASHIER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_OPERATOR,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/payment-tickets/finished'
          title='Завершённые'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_CASHIER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_OPERATOR,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/payout-tickets/'
        title='Тикеты выплат'
        icon='double-down'
        fontIcon='bi-person'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_CASHIER,
          ROLE.ROLE_SENIOR_OPERATOR,
          ROLE.ROLE_OPERATOR,
          ROLE.ROLE_MATCHING_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/payout-tickets/active'
          title='Активные'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_OPERATOR,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/payout-tickets/finished'
          title='Завершённые'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_OPERATOR,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/payout-tickets/report'
          title='Отчёты'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
          ]}
        />
        <SidebarMenuItem
          to='/payout-tickets/refusals'
          title='Отказы'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
            ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/reports/'
        title='Отчёты'
        icon='book'
        fontIcon='bi-person'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_SENIOR_CASHIER,
          ROLE.ROLE_SENIOR_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/reports/payment'
          title='Отчёт по пополнениям'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/reports/payout'
          title='Отчёт по выплатам'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_CASHIER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        {/* CPAYMENT-1760: без кассиров и старших кассиров — отчёт считает объём по владельцу
            депозитного чанка, кассовой смене он ничего не говорит. */}
        <SidebarMenuItem
          to='/reports/matching-payout'
          title='Отчёт по выплатам мэтчинга'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
      </SidebarMenuItemWithSub>
      {!!IsGranted([ROLE.ROLE_MANAGER, ROLE.ROLE_ADMIN, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Мэтчинг</span>
          </div>
        </div>
      )}
      {/* CPAYMENT-1814: оператору платежей мерчанта раздел открыт целиком по ПС, без сужения
          своими мерчантами. Список ролей обязан совпадать с dashboardRoles в MatchingPage. */}
      <SidebarMenuItemWithSub
        to='/matching/dashboard'
        title='Состояние мэтчинга'
        icon='chart-simple'
        fontIcon='bi-speedometer2'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
        ]}
      >
        <SidebarMenuItem
          to='/matching/dashboard'
          title='Обзор'
          hasBullet={true}
          exact={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ]}
        />
        <SidebarMenuItem
          to='/matching/dashboard/timeline'
          title='Таймлайн депозитов к выплатам'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ]}
        />
        <SidebarMenuItem
          to='/matching/dashboard/charts'
          title='Графики'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/matching/payment/'
        title='Пополнения'
        icon='exit-right'
        fontIcon='bi-arrow-repeat'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MATCHING_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/matching/payment/active'
          title='Активные'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/matching/payment/finished'
          title='Завершённые'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/matching/payout/'
        title='Выплаты'
        icon='exit-left'
        fontIcon='bi-arrow-repeat'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MATCHING_OPERATOR,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      >
        <SidebarMenuItem
          to='/matching/payout/active'
          title='Активные'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/matching/payout/finished'
          title='Завершённые'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
        <SidebarMenuItem
          to='/matching/payout/refusals'
          title='Отказы'
          hasBullet={true}
          roles={[
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_MATCHING_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
          ]}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/matching/virtual-merchant'
        title='Виртуальный мерчант'
        icon='shop'
        fontIcon='bi-shop'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
        ]}
      />
      <SidebarMenuItem
        to='/matching/overpayments'
        title='Переоплаты'
        icon='wallet'
        fontIcon='bi-wallet2'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      />
      <SidebarMenuItem
        to='/matching/disputes'
        title='Диспуты'
        icon='shield-cross'
        fontIcon='bi-shield-exclamation'
        roles={[
          ROLE.ROLE_ADMIN,
          ROLE.ROLE_MANAGER,
          ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
          ROLE.ROLE_MERCHANT_MANAGER,
        ]}
      />
    </>
  )
}

export { SidebarMenuMain }
